/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiagnosticsEmbed } from './DiagnosticsEmbed';
import {
    DiagnosticsEmbedFromJSON,
    DiagnosticsEmbedFromJSONTyped,
    DiagnosticsEmbedToJSON,
    DiagnosticsEmbedToJSONTyped,
} from './DiagnosticsEmbed';
import type { HistoryDataPointItem } from './HistoryDataPointItem';
import {
    HistoryDataPointItemFromJSON,
    HistoryDataPointItemFromJSONTyped,
    HistoryDataPointItemToJSON,
    HistoryDataPointItemToJSONTyped,
} from './HistoryDataPointItem';

/**
 * 
 * @export
 * @interface HistoryDataPoints
 */
export interface HistoryDataPoints {
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airAs200SensorState?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airDuctsPosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airExhaustTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airExternalTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airFanSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airFlowSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airIndoorHumidity?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airOutdoorTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airReturnSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airReturnTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airThermalResistance?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    airVentilationFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ambientEco2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ambientHumidity?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ambientTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ambientTvoc?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    antiFreezeProtectionActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    backupHeater1Active?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    backupHeater2Active?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    backupHeater3Active?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerDemandActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerDhwValveState?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerElementActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerNtc1Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerNtc2Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerNtc3Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerNtc4Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerValveZone1StateActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerValveZone2StateActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerValveZone3StateActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingEnabled?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingOrDomesticHotWaterActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingPumpOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingPumpPwm?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingPumpStartStopCount?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingTemperatureTooHigh?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingTotalEnergyConsumed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    centralHeatingWaterPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    compressorAntiToggleActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    compressorEnabled?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    compressorOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    compressorTotalEnergyConsumed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    connected?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    cop?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    disconnectReason?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAirExhaustFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAirIntakeFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalTemperatureSensorActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    filterChangeRequiredWithinDays?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpAirExhaustTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpAuxiliaryHeatingDegreeMinutes?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpCondensationPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpCondensationTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpCondenserRefrigerantOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpCurrentCompressorSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDefrostFreezingValue?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDefrostFreezingValueThreshold?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDesiredAirIndoorValveSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDesiredAirOutdoorValveSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDesiredCompressorSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDesiredReverseCyclePositionIsCooling?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedAirFanSpeedSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedAirIndoorValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedAirOutdoorValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedCentralHeatingSupplyTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedCompressorSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedSuperheatExpansionValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpDeterminedWaterPumpSpeedSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpEvaporationPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpEvaporationTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpEvaporatorRefrigerantOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpHotGasTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpInverterFaultCode?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpInverterInputPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpMaximumCompressorSpeedEnvelope?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpMaximumCompressorSpeedHotgas?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpMinimumCompressorSpeedEnvelope?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpRoomSetpointTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpSpareTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatPumpTotalOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatRecoveryValveCentralHeatingActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    heatRecoveryValveHalfActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    hotWaterCapacity?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    hotWaterSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    hotWaterTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    internalAirIntakeFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    legionellaPreventionActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    nightclockActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    performanceEnergyConsumptionL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    performanceEnergyConsumptionL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    performanceEnergyConsumptionL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    performancePowerUsageL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    performancePowerUsageL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    performancePowerUsageL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    pureAirAirInTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    pureAirAirOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    pureAirDeterminedFanSpeedSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    pureAirEstimatedWaterValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    pureAirFanSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    requestedHeatingTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    reverseCyclePositionIsCooling?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    roomCurrentUba?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    suppliedEnergyCentralHeating?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    suppliedEnergyDomesticHotWater?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    suppliedEnergyHeatRecoveryModule?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    systemActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    thermostatHybridChEnable?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ventilationRequestedAutoDemand?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ventilationTotalEnergyConsumed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ventilatorOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ventilatorPwm?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    waterCondenserWaterOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    waterFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    waterPumpFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    waterPumpStatus?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    waterReturnTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    waterSupplyTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {DiagnosticsEmbed}
     * @memberof HistoryDataPoints
     */
    diagnostics?: DiagnosticsEmbed;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ambientOffset?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    boilerControlMode?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedAuxHeatEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCentralHeatingAuxEnergyCalculated?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCentralHeatingAuxPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCentralHeatingAuxPowerCalculated?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCentralHeatingHeatPumpEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCentralHeatingHeatPumpPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCopHeatPump?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedCopTotal?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedDomesticHotWaterAuxEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedDomesticHotWaterAuxEnergyCalculated?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedDomesticHotWaterAuxPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedDomesticHotWaterHeatPumpEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedDomesticHotWaterHeatPumpPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedElectricEnergyL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedElectricEnergyL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedElectricEnergyL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedElectricEnergyTotal?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedHeatPumpHeatEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedTotalEnergyCalculated?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedTotalHeatEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    calculatedTotalPowerCalculated?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    climateMode?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    displayBrightness?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAuxEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAuxFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAuxPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAuxReturnTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalAuxSupplyTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalCentralHeatingAuxEnergyDelta?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalCentralHeatingHeatPumpEnergyDelta?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalCurrentL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalCurrentL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalCurrentL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalCurrentN?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalDefrostThreshold?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalDefrostValue?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalDegreeMinutes?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalDifferentialPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalDomesticHotWaterAuxEnergyDelta?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalDomesticHotWaterHeatPumpEnergyDelta?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricEnergyL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricEnergyL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricEnergyL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricEnergyTotal?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricPowerL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricPowerL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricPowerL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalElectricPowerTotal?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalEnergyDeltaTotal?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalTotalFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalTotalHeatEnergy?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalTotalPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalTotalReturnTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalTotalSupplyTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalVoltageL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalVoltageL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalVoltageL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    externalWaterTargetTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    flameState?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    preheatSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    remoteLoggingEnabled?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    roomSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    ventilationLevel?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof HistoryDataPoints
     */
    weekscheduleState?: HistoryDataPointItem;
}

/**
 * Check if a given object implements the HistoryDataPoints interface.
 */
export function instanceOfHistoryDataPoints(value: object): value is HistoryDataPoints {
    return true;
}

export function HistoryDataPointsFromJSON(json: any): HistoryDataPoints {
    return HistoryDataPointsFromJSONTyped(json, false);
}

export function HistoryDataPointsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDataPoints {
    if (json == null) {
        return json;
    }
    return {
        
        'airAs200SensorState': json['air_as200_sensor_state'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_as200_sensor_state']),
        'airDuctsPosition': json['air_ducts_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_ducts_position']),
        'airExhaustTemperature': json['air_exhaust_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_exhaust_temperature']),
        'airExternalTemperature': json['air_external_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_external_temperature']),
        'airFanSpeed': json['air_fan_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_fan_speed']),
        'airFlowSetpoint': json['air_flow_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_flow_setpoint']),
        'airIndoorHumidity': json['air_indoor_humidity'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_indoor_humidity']),
        'airOutdoorTemperature': json['air_outdoor_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_outdoor_temperature']),
        'airReturnSpeed': json['air_return_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_return_speed']),
        'airReturnTemperature': json['air_return_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_return_temperature']),
        'airThermalResistance': json['air_thermal_resistance'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_thermal_resistance']),
        'airVentilationFlow': json['air_ventilation_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_ventilation_flow']),
        'ambientEco2': json['ambient_eco2'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_eco2']),
        'ambientHumidity': json['ambient_humidity'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_humidity']),
        'ambientTemperature': json['ambient_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_temperature']),
        'ambientTvoc': json['ambient_tvoc'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_tvoc']),
        'antiFreezeProtectionActive': json['anti_freeze_protection_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['anti_freeze_protection_active']),
        'backupHeater1Active': json['backup_heater_1_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['backup_heater_1_active']),
        'backupHeater2Active': json['backup_heater_2_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['backup_heater_2_active']),
        'backupHeater3Active': json['backup_heater_3_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['backup_heater_3_active']),
        'boilerDemandActive': json['boiler_demand_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_demand_active']),
        'boilerDhwValveState': json['boiler_dhw_valve_state'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_dhw_valve_state']),
        'boilerElementActive': json['boiler_element_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_element_active']),
        'boilerNtc1Temperature': json['boiler_ntc_1_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_1_temperature']),
        'boilerNtc2Temperature': json['boiler_ntc_2_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_2_temperature']),
        'boilerNtc3Temperature': json['boiler_ntc_3_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_3_temperature']),
        'boilerNtc4Temperature': json['boiler_ntc_4_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_4_temperature']),
        'boilerValveZone1StateActive': json['boiler_valve_zone_1_state_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_valve_zone_1_state_active']),
        'boilerValveZone2StateActive': json['boiler_valve_zone_2_state_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_valve_zone_2_state_active']),
        'boilerValveZone3StateActive': json['boiler_valve_zone_3_state_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_valve_zone_3_state_active']),
        'centralHeatingEnabled': json['central_heating_enabled'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_enabled']),
        'centralHeatingOrDomesticHotWaterActive': json['central_heating_or_domestic_hot_water_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_or_domestic_hot_water_active']),
        'centralHeatingPumpOperationHours': json['central_heating_pump_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_pump_operation_hours']),
        'centralHeatingPumpPwm': json['central_heating_pump_pwm'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_pump_pwm']),
        'centralHeatingPumpStartStopCount': json['central_heating_pump_start_stop_count'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_pump_start_stop_count']),
        'centralHeatingTemperatureTooHigh': json['central_heating_temperature_too_high'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_temperature_too_high']),
        'centralHeatingTotalEnergyConsumed': json['central_heating_total_energy_consumed'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_total_energy_consumed']),
        'centralHeatingWaterPressure': json['central_heating_water_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_water_pressure']),
        'compressorAntiToggleActive': json['compressor_anti_toggle_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_anti_toggle_active']),
        'compressorEnabled': json['compressor_enabled'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_enabled']),
        'compressorOperationHours': json['compressor_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_operation_hours']),
        'compressorTotalEnergyConsumed': json['compressor_total_energy_consumed'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_total_energy_consumed']),
        'connected': json['connected'] == null ? undefined : HistoryDataPointItemFromJSON(json['connected']),
        'cop': json['cop'] == null ? undefined : HistoryDataPointItemFromJSON(json['cop']),
        'disconnectReason': json['disconnect_reason'] == null ? undefined : HistoryDataPointItemFromJSON(json['disconnect_reason']),
        'externalAirExhaustFlow': json['external_air_exhaust_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_air_exhaust_flow']),
        'externalAirIntakeFlow': json['external_air_intake_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_air_intake_flow']),
        'externalTemperatureSensorActive': json['external_temperature_sensor_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_temperature_sensor_active']),
        'filterChangeRequiredWithinDays': json['filter_change_required_within_days'] == null ? undefined : HistoryDataPointItemFromJSON(json['filter_change_required_within_days']),
        'heatPumpAirExhaustTemperature': json['heat_pump_air_exhaust_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_air_exhaust_temperature']),
        'heatPumpAuxiliaryHeatingDegreeMinutes': json['heat_pump_auxiliary_heating_degree_minutes'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_auxiliary_heating_degree_minutes']),
        'heatPumpCondensationPressure': json['heat_pump_condensation_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_condensation_pressure']),
        'heatPumpCondensationTemperature': json['heat_pump_condensation_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_condensation_temperature']),
        'heatPumpCondenserRefrigerantOutTemperature': json['heat_pump_condenser_refrigerant_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_condenser_refrigerant_out_temperature']),
        'heatPumpCurrentCompressorSpeed': json['heat_pump_current_compressor_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_current_compressor_speed']),
        'heatPumpDefrostFreezingValue': json['heat_pump_defrost_freezing_value'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_defrost_freezing_value']),
        'heatPumpDefrostFreezingValueThreshold': json['heat_pump_defrost_freezing_value_threshold'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_defrost_freezing_value_threshold']),
        'heatPumpDesiredAirIndoorValveSetpoint': json['heat_pump_desired_air_indoor_valve_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_air_indoor_valve_setpoint']),
        'heatPumpDesiredAirOutdoorValveSetpoint': json['heat_pump_desired_air_outdoor_valve_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_air_outdoor_valve_setpoint']),
        'heatPumpDesiredCompressorSpeed': json['heat_pump_desired_compressor_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_compressor_speed']),
        'heatPumpDesiredReverseCyclePositionIsCooling': json['heat_pump_desired_reverse_cycle_position_is_cooling'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_reverse_cycle_position_is_cooling']),
        'heatPumpDeterminedAirFanSpeedSetpoint': json['heat_pump_determined_air_fan_speed_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_air_fan_speed_setpoint']),
        'heatPumpDeterminedAirIndoorValvePosition': json['heat_pump_determined_air_indoor_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_air_indoor_valve_position']),
        'heatPumpDeterminedAirOutdoorValvePosition': json['heat_pump_determined_air_outdoor_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_air_outdoor_valve_position']),
        'heatPumpDeterminedCentralHeatingSupplyTemperature': json['heat_pump_determined_central_heating_supply_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_central_heating_supply_temperature']),
        'heatPumpDeterminedCompressorSpeed': json['heat_pump_determined_compressor_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_compressor_speed']),
        'heatPumpDeterminedSuperheatExpansionValvePosition': json['heat_pump_determined_superheat_expansion_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_superheat_expansion_valve_position']),
        'heatPumpDeterminedWaterPumpSpeedSetpoint': json['heat_pump_determined_water_pump_speed_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_water_pump_speed_setpoint']),
        'heatPumpEvaporationPressure': json['heat_pump_evaporation_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_evaporation_pressure']),
        'heatPumpEvaporationTemperature': json['heat_pump_evaporation_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_evaporation_temperature']),
        'heatPumpEvaporatorRefrigerantOutTemperature': json['heat_pump_evaporator_refrigerant_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_evaporator_refrigerant_out_temperature']),
        'heatPumpHotGasTemperature': json['heat_pump_hot_gas_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_hot_gas_temperature']),
        'heatPumpInverterFaultCode': json['heat_pump_inverter_fault_code'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_inverter_fault_code']),
        'heatPumpInverterInputPower': json['heat_pump_inverter_input_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_inverter_input_power']),
        'heatPumpMaximumCompressorSpeedEnvelope': json['heat_pump_maximum_compressor_speed_envelope'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_maximum_compressor_speed_envelope']),
        'heatPumpMaximumCompressorSpeedHotgas': json['heat_pump_maximum_compressor_speed_hotgas'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_maximum_compressor_speed_hotgas']),
        'heatPumpMinimumCompressorSpeedEnvelope': json['heat_pump_minimum_compressor_speed_envelope'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_minimum_compressor_speed_envelope']),
        'heatPumpRoomSetpointTemperature': json['heat_pump_room_setpoint_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_room_setpoint_temperature']),
        'heatPumpSpareTemperature': json['heat_pump_spare_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_spare_temperature']),
        'heatPumpTotalOperationHours': json['heat_pump_total_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_total_operation_hours']),
        'heatRecoveryValveCentralHeatingActive': json['heat_recovery_valve_central_heating_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_recovery_valve_central_heating_active']),
        'heatRecoveryValveHalfActive': json['heat_recovery_valve_half_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_recovery_valve_half_active']),
        'hotWaterCapacity': json['hot_water_capacity'] == null ? undefined : HistoryDataPointItemFromJSON(json['hot_water_capacity']),
        'hotWaterSetpoint': json['hot_water_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['hot_water_setpoint']),
        'hotWaterTemperature': json['hot_water_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['hot_water_temperature']),
        'internalAirIntakeFlow': json['internal_air_intake_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['internal_air_intake_flow']),
        'legionellaPreventionActive': json['legionella_prevention_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['legionella_prevention_active']),
        'nightclockActive': json['nightclock_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['nightclock_active']),
        'performanceEnergyConsumptionL1': json['performance_energy_consumption_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_energy_consumption_l1']),
        'performanceEnergyConsumptionL2': json['performance_energy_consumption_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_energy_consumption_l2']),
        'performanceEnergyConsumptionL3': json['performance_energy_consumption_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_energy_consumption_l3']),
        'performancePowerUsageL1': json['performance_power_usage_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_power_usage_l1']),
        'performancePowerUsageL2': json['performance_power_usage_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_power_usage_l2']),
        'performancePowerUsageL3': json['performance_power_usage_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_power_usage_l3']),
        'pureAirAirInTemperature': json['pure_air_air_in_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_air_in_temperature']),
        'pureAirAirOutTemperature': json['pure_air_air_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_air_out_temperature']),
        'pureAirDeterminedFanSpeedSetpoint': json['pure_air_determined_fan_speed_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_determined_fan_speed_setpoint']),
        'pureAirEstimatedWaterValvePosition': json['pure_air_estimated_water_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_estimated_water_valve_position']),
        'pureAirFanSpeed': json['pure_air_fan_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_fan_speed']),
        'requestedHeatingTemperature': json['requested_heating_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['requested_heating_temperature']),
        'reverseCyclePositionIsCooling': json['reverse_cycle_position_is_cooling'] == null ? undefined : HistoryDataPointItemFromJSON(json['reverse_cycle_position_is_cooling']),
        'roomCurrentUba': json['room_current_uba'] == null ? undefined : HistoryDataPointItemFromJSON(json['room_current_uba']),
        'suppliedEnergyCentralHeating': json['supplied_energy_central_heating'] == null ? undefined : HistoryDataPointItemFromJSON(json['supplied_energy_central_heating']),
        'suppliedEnergyDomesticHotWater': json['supplied_energy_domestic_hot_water'] == null ? undefined : HistoryDataPointItemFromJSON(json['supplied_energy_domestic_hot_water']),
        'suppliedEnergyHeatRecoveryModule': json['supplied_energy_heat_recovery_module'] == null ? undefined : HistoryDataPointItemFromJSON(json['supplied_energy_heat_recovery_module']),
        'systemActive': json['system_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['system_active']),
        'thermostatHybridChEnable': json['thermostat_hybrid_ch_enable'] == null ? undefined : HistoryDataPointItemFromJSON(json['thermostat_hybrid_ch_enable']),
        'ventilationRequestedAutoDemand': json['ventilation_requested_auto_demand'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilation_requested_auto_demand']),
        'ventilationTotalEnergyConsumed': json['ventilation_total_energy_consumed'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilation_total_energy_consumed']),
        'ventilatorOperationHours': json['ventilator_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilator_operation_hours']),
        'ventilatorPwm': json['ventilator_pwm'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilator_pwm']),
        'waterCondenserWaterOutTemperature': json['water_condenser_water_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_condenser_water_out_temperature']),
        'waterFlow': json['water_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_flow']),
        'waterPumpFlow': json['water_pump_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_pump_flow']),
        'waterPumpStatus': json['water_pump_status'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_pump_status']),
        'waterReturnTemperature': json['water_return_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_return_temperature']),
        'waterSupplyTemperature': json['water_supply_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_supply_temperature']),
        'diagnostics': json['diagnostics'] == null ? undefined : DiagnosticsEmbedFromJSON(json['diagnostics']),
        'ambientOffset': json['ambient_offset'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_offset']),
        'boilerControlMode': json['boiler_control_mode'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_control_mode']),
        'calculatedAuxHeatEnergy': json['calculated_aux_heat_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_aux_heat_energy']),
        'calculatedCentralHeatingAuxEnergyCalculated': json['calculated_central_heating_aux_energy_calculated'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_central_heating_aux_energy_calculated']),
        'calculatedCentralHeatingAuxPower': json['calculated_central_heating_aux_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_central_heating_aux_power']),
        'calculatedCentralHeatingAuxPowerCalculated': json['calculated_central_heating_aux_power_calculated'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_central_heating_aux_power_calculated']),
        'calculatedCentralHeatingHeatPumpEnergy': json['calculated_central_heating_heat_pump_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_central_heating_heat_pump_energy']),
        'calculatedCentralHeatingHeatPumpPower': json['calculated_central_heating_heat_pump_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_central_heating_heat_pump_power']),
        'calculatedCopHeatPump': json['calculated_cop_heat_pump'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_cop_heat_pump']),
        'calculatedCopTotal': json['calculated_cop_total'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_cop_total']),
        'calculatedDomesticHotWaterAuxEnergy': json['calculated_domestic_hot_water_aux_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_domestic_hot_water_aux_energy']),
        'calculatedDomesticHotWaterAuxEnergyCalculated': json['calculated_domestic_hot_water_aux_energy_calculated'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_domestic_hot_water_aux_energy_calculated']),
        'calculatedDomesticHotWaterAuxPower': json['calculated_domestic_hot_water_aux_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_domestic_hot_water_aux_power']),
        'calculatedDomesticHotWaterHeatPumpEnergy': json['calculated_domestic_hot_water_heat_pump_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_domestic_hot_water_heat_pump_energy']),
        'calculatedDomesticHotWaterHeatPumpPower': json['calculated_domestic_hot_water_heat_pump_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_domestic_hot_water_heat_pump_power']),
        'calculatedElectricEnergyL1': json['calculated_electric_energy_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_electric_energy_l1']),
        'calculatedElectricEnergyL2': json['calculated_electric_energy_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_electric_energy_l2']),
        'calculatedElectricEnergyL3': json['calculated_electric_energy_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_electric_energy_l3']),
        'calculatedElectricEnergyTotal': json['calculated_electric_energy_total'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_electric_energy_total']),
        'calculatedHeatPumpHeatEnergy': json['calculated_heat_pump_heat_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_heat_pump_heat_energy']),
        'calculatedTotalEnergyCalculated': json['calculated_total_energy_calculated'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_total_energy_calculated']),
        'calculatedTotalHeatEnergy': json['calculated_total_heat_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_total_heat_energy']),
        'calculatedTotalPowerCalculated': json['calculated_total_power_calculated'] == null ? undefined : HistoryDataPointItemFromJSON(json['calculated_total_power_calculated']),
        'climateMode': json['climate_mode'] == null ? undefined : HistoryDataPointItemFromJSON(json['climate_mode']),
        'displayBrightness': json['display_brightness'] == null ? undefined : HistoryDataPointItemFromJSON(json['display_brightness']),
        'externalAuxEnergy': json['external_aux_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_aux_energy']),
        'externalAuxFlow': json['external_aux_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_aux_flow']),
        'externalAuxPower': json['external_aux_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_aux_power']),
        'externalAuxReturnTemperature': json['external_aux_return_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_aux_return_temperature']),
        'externalAuxSupplyTemperature': json['external_aux_supply_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_aux_supply_temperature']),
        'externalCentralHeatingAuxEnergyDelta': json['external_central_heating_aux_energy_delta'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_central_heating_aux_energy_delta']),
        'externalCentralHeatingHeatPumpEnergyDelta': json['external_central_heating_heat_pump_energy_delta'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_central_heating_heat_pump_energy_delta']),
        'externalCurrentL1': json['external_current_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_current_l1']),
        'externalCurrentL2': json['external_current_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_current_l2']),
        'externalCurrentL3': json['external_current_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_current_l3']),
        'externalCurrentN': json['external_current_n'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_current_n']),
        'externalDefrostThreshold': json['external_defrost_threshold'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_defrost_threshold']),
        'externalDefrostValue': json['external_defrost_value'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_defrost_value']),
        'externalDegreeMinutes': json['external_degree_minutes'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_degree_minutes']),
        'externalDifferentialPressure': json['external_differential_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_differential_pressure']),
        'externalDomesticHotWaterAuxEnergyDelta': json['external_domestic_hot_water_aux_energy_delta'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_domestic_hot_water_aux_energy_delta']),
        'externalDomesticHotWaterHeatPumpEnergyDelta': json['external_domestic_hot_water_heat_pump_energy_delta'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_domestic_hot_water_heat_pump_energy_delta']),
        'externalElectricEnergyL1': json['external_electric_energy_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_energy_l1']),
        'externalElectricEnergyL2': json['external_electric_energy_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_energy_l2']),
        'externalElectricEnergyL3': json['external_electric_energy_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_energy_l3']),
        'externalElectricEnergyTotal': json['external_electric_energy_total'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_energy_total']),
        'externalElectricPowerL1': json['external_electric_power_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_power_l1']),
        'externalElectricPowerL2': json['external_electric_power_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_power_l2']),
        'externalElectricPowerL3': json['external_electric_power_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_power_l3']),
        'externalElectricPowerTotal': json['external_electric_power_total'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_electric_power_total']),
        'externalEnergyDeltaTotal': json['external_energy_delta_total'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_energy_delta_total']),
        'externalTotalFlow': json['external_total_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_total_flow']),
        'externalTotalHeatEnergy': json['external_total_heat_energy'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_total_heat_energy']),
        'externalTotalPower': json['external_total_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_total_power']),
        'externalTotalReturnTemperature': json['external_total_return_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_total_return_temperature']),
        'externalTotalSupplyTemperature': json['external_total_supply_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_total_supply_temperature']),
        'externalVoltageL1': json['external_voltage_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_voltage_l1']),
        'externalVoltageL2': json['external_voltage_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_voltage_l2']),
        'externalVoltageL3': json['external_voltage_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_voltage_l3']),
        'externalWaterTargetTemperature': json['external_water_target_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_water_target_temperature']),
        'flameState': json['flame_state'] == null ? undefined : HistoryDataPointItemFromJSON(json['flame_state']),
        'preheatSetpoint': json['preheat_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['preheat_setpoint']),
        'remoteLoggingEnabled': json['remote_logging_enabled'] == null ? undefined : HistoryDataPointItemFromJSON(json['remote_logging_enabled']),
        'roomSetpoint': json['room_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['room_setpoint']),
        'ventilationLevel': json['ventilation_level'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilation_level']),
        'weekscheduleState': json['weekschedule_state'] == null ? undefined : HistoryDataPointItemFromJSON(json['weekschedule_state']),
    };
}

export function HistoryDataPointsToJSON(json: any): HistoryDataPoints {
    return HistoryDataPointsToJSONTyped(json, false);
}

export function HistoryDataPointsToJSONTyped(value?: HistoryDataPoints | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'air_as200_sensor_state': HistoryDataPointItemToJSON(value['airAs200SensorState']),
        'air_ducts_position': HistoryDataPointItemToJSON(value['airDuctsPosition']),
        'air_exhaust_temperature': HistoryDataPointItemToJSON(value['airExhaustTemperature']),
        'air_external_temperature': HistoryDataPointItemToJSON(value['airExternalTemperature']),
        'air_fan_speed': HistoryDataPointItemToJSON(value['airFanSpeed']),
        'air_flow_setpoint': HistoryDataPointItemToJSON(value['airFlowSetpoint']),
        'air_indoor_humidity': HistoryDataPointItemToJSON(value['airIndoorHumidity']),
        'air_outdoor_temperature': HistoryDataPointItemToJSON(value['airOutdoorTemperature']),
        'air_return_speed': HistoryDataPointItemToJSON(value['airReturnSpeed']),
        'air_return_temperature': HistoryDataPointItemToJSON(value['airReturnTemperature']),
        'air_thermal_resistance': HistoryDataPointItemToJSON(value['airThermalResistance']),
        'air_ventilation_flow': HistoryDataPointItemToJSON(value['airVentilationFlow']),
        'ambient_eco2': HistoryDataPointItemToJSON(value['ambientEco2']),
        'ambient_humidity': HistoryDataPointItemToJSON(value['ambientHumidity']),
        'ambient_temperature': HistoryDataPointItemToJSON(value['ambientTemperature']),
        'ambient_tvoc': HistoryDataPointItemToJSON(value['ambientTvoc']),
        'anti_freeze_protection_active': HistoryDataPointItemToJSON(value['antiFreezeProtectionActive']),
        'backup_heater_1_active': HistoryDataPointItemToJSON(value['backupHeater1Active']),
        'backup_heater_2_active': HistoryDataPointItemToJSON(value['backupHeater2Active']),
        'backup_heater_3_active': HistoryDataPointItemToJSON(value['backupHeater3Active']),
        'boiler_demand_active': HistoryDataPointItemToJSON(value['boilerDemandActive']),
        'boiler_dhw_valve_state': HistoryDataPointItemToJSON(value['boilerDhwValveState']),
        'boiler_element_active': HistoryDataPointItemToJSON(value['boilerElementActive']),
        'boiler_ntc_1_temperature': HistoryDataPointItemToJSON(value['boilerNtc1Temperature']),
        'boiler_ntc_2_temperature': HistoryDataPointItemToJSON(value['boilerNtc2Temperature']),
        'boiler_ntc_3_temperature': HistoryDataPointItemToJSON(value['boilerNtc3Temperature']),
        'boiler_ntc_4_temperature': HistoryDataPointItemToJSON(value['boilerNtc4Temperature']),
        'boiler_valve_zone_1_state_active': HistoryDataPointItemToJSON(value['boilerValveZone1StateActive']),
        'boiler_valve_zone_2_state_active': HistoryDataPointItemToJSON(value['boilerValveZone2StateActive']),
        'boiler_valve_zone_3_state_active': HistoryDataPointItemToJSON(value['boilerValveZone3StateActive']),
        'central_heating_enabled': HistoryDataPointItemToJSON(value['centralHeatingEnabled']),
        'central_heating_or_domestic_hot_water_active': HistoryDataPointItemToJSON(value['centralHeatingOrDomesticHotWaterActive']),
        'central_heating_pump_operation_hours': HistoryDataPointItemToJSON(value['centralHeatingPumpOperationHours']),
        'central_heating_pump_pwm': HistoryDataPointItemToJSON(value['centralHeatingPumpPwm']),
        'central_heating_pump_start_stop_count': HistoryDataPointItemToJSON(value['centralHeatingPumpStartStopCount']),
        'central_heating_temperature_too_high': HistoryDataPointItemToJSON(value['centralHeatingTemperatureTooHigh']),
        'central_heating_total_energy_consumed': HistoryDataPointItemToJSON(value['centralHeatingTotalEnergyConsumed']),
        'central_heating_water_pressure': HistoryDataPointItemToJSON(value['centralHeatingWaterPressure']),
        'compressor_anti_toggle_active': HistoryDataPointItemToJSON(value['compressorAntiToggleActive']),
        'compressor_enabled': HistoryDataPointItemToJSON(value['compressorEnabled']),
        'compressor_operation_hours': HistoryDataPointItemToJSON(value['compressorOperationHours']),
        'compressor_total_energy_consumed': HistoryDataPointItemToJSON(value['compressorTotalEnergyConsumed']),
        'connected': HistoryDataPointItemToJSON(value['connected']),
        'cop': HistoryDataPointItemToJSON(value['cop']),
        'disconnect_reason': HistoryDataPointItemToJSON(value['disconnectReason']),
        'external_air_exhaust_flow': HistoryDataPointItemToJSON(value['externalAirExhaustFlow']),
        'external_air_intake_flow': HistoryDataPointItemToJSON(value['externalAirIntakeFlow']),
        'external_temperature_sensor_active': HistoryDataPointItemToJSON(value['externalTemperatureSensorActive']),
        'filter_change_required_within_days': HistoryDataPointItemToJSON(value['filterChangeRequiredWithinDays']),
        'heat_pump_air_exhaust_temperature': HistoryDataPointItemToJSON(value['heatPumpAirExhaustTemperature']),
        'heat_pump_auxiliary_heating_degree_minutes': HistoryDataPointItemToJSON(value['heatPumpAuxiliaryHeatingDegreeMinutes']),
        'heat_pump_condensation_pressure': HistoryDataPointItemToJSON(value['heatPumpCondensationPressure']),
        'heat_pump_condensation_temperature': HistoryDataPointItemToJSON(value['heatPumpCondensationTemperature']),
        'heat_pump_condenser_refrigerant_out_temperature': HistoryDataPointItemToJSON(value['heatPumpCondenserRefrigerantOutTemperature']),
        'heat_pump_current_compressor_speed': HistoryDataPointItemToJSON(value['heatPumpCurrentCompressorSpeed']),
        'heat_pump_defrost_freezing_value': HistoryDataPointItemToJSON(value['heatPumpDefrostFreezingValue']),
        'heat_pump_defrost_freezing_value_threshold': HistoryDataPointItemToJSON(value['heatPumpDefrostFreezingValueThreshold']),
        'heat_pump_desired_air_indoor_valve_setpoint': HistoryDataPointItemToJSON(value['heatPumpDesiredAirIndoorValveSetpoint']),
        'heat_pump_desired_air_outdoor_valve_setpoint': HistoryDataPointItemToJSON(value['heatPumpDesiredAirOutdoorValveSetpoint']),
        'heat_pump_desired_compressor_speed': HistoryDataPointItemToJSON(value['heatPumpDesiredCompressorSpeed']),
        'heat_pump_desired_reverse_cycle_position_is_cooling': HistoryDataPointItemToJSON(value['heatPumpDesiredReverseCyclePositionIsCooling']),
        'heat_pump_determined_air_fan_speed_setpoint': HistoryDataPointItemToJSON(value['heatPumpDeterminedAirFanSpeedSetpoint']),
        'heat_pump_determined_air_indoor_valve_position': HistoryDataPointItemToJSON(value['heatPumpDeterminedAirIndoorValvePosition']),
        'heat_pump_determined_air_outdoor_valve_position': HistoryDataPointItemToJSON(value['heatPumpDeterminedAirOutdoorValvePosition']),
        'heat_pump_determined_central_heating_supply_temperature': HistoryDataPointItemToJSON(value['heatPumpDeterminedCentralHeatingSupplyTemperature']),
        'heat_pump_determined_compressor_speed': HistoryDataPointItemToJSON(value['heatPumpDeterminedCompressorSpeed']),
        'heat_pump_determined_superheat_expansion_valve_position': HistoryDataPointItemToJSON(value['heatPumpDeterminedSuperheatExpansionValvePosition']),
        'heat_pump_determined_water_pump_speed_setpoint': HistoryDataPointItemToJSON(value['heatPumpDeterminedWaterPumpSpeedSetpoint']),
        'heat_pump_evaporation_pressure': HistoryDataPointItemToJSON(value['heatPumpEvaporationPressure']),
        'heat_pump_evaporation_temperature': HistoryDataPointItemToJSON(value['heatPumpEvaporationTemperature']),
        'heat_pump_evaporator_refrigerant_out_temperature': HistoryDataPointItemToJSON(value['heatPumpEvaporatorRefrigerantOutTemperature']),
        'heat_pump_hot_gas_temperature': HistoryDataPointItemToJSON(value['heatPumpHotGasTemperature']),
        'heat_pump_inverter_fault_code': HistoryDataPointItemToJSON(value['heatPumpInverterFaultCode']),
        'heat_pump_inverter_input_power': HistoryDataPointItemToJSON(value['heatPumpInverterInputPower']),
        'heat_pump_maximum_compressor_speed_envelope': HistoryDataPointItemToJSON(value['heatPumpMaximumCompressorSpeedEnvelope']),
        'heat_pump_maximum_compressor_speed_hotgas': HistoryDataPointItemToJSON(value['heatPumpMaximumCompressorSpeedHotgas']),
        'heat_pump_minimum_compressor_speed_envelope': HistoryDataPointItemToJSON(value['heatPumpMinimumCompressorSpeedEnvelope']),
        'heat_pump_room_setpoint_temperature': HistoryDataPointItemToJSON(value['heatPumpRoomSetpointTemperature']),
        'heat_pump_spare_temperature': HistoryDataPointItemToJSON(value['heatPumpSpareTemperature']),
        'heat_pump_total_operation_hours': HistoryDataPointItemToJSON(value['heatPumpTotalOperationHours']),
        'heat_recovery_valve_central_heating_active': HistoryDataPointItemToJSON(value['heatRecoveryValveCentralHeatingActive']),
        'heat_recovery_valve_half_active': HistoryDataPointItemToJSON(value['heatRecoveryValveHalfActive']),
        'hot_water_capacity': HistoryDataPointItemToJSON(value['hotWaterCapacity']),
        'hot_water_setpoint': HistoryDataPointItemToJSON(value['hotWaterSetpoint']),
        'hot_water_temperature': HistoryDataPointItemToJSON(value['hotWaterTemperature']),
        'internal_air_intake_flow': HistoryDataPointItemToJSON(value['internalAirIntakeFlow']),
        'legionella_prevention_active': HistoryDataPointItemToJSON(value['legionellaPreventionActive']),
        'nightclock_active': HistoryDataPointItemToJSON(value['nightclockActive']),
        'performance_energy_consumption_l1': HistoryDataPointItemToJSON(value['performanceEnergyConsumptionL1']),
        'performance_energy_consumption_l2': HistoryDataPointItemToJSON(value['performanceEnergyConsumptionL2']),
        'performance_energy_consumption_l3': HistoryDataPointItemToJSON(value['performanceEnergyConsumptionL3']),
        'performance_power_usage_l1': HistoryDataPointItemToJSON(value['performancePowerUsageL1']),
        'performance_power_usage_l2': HistoryDataPointItemToJSON(value['performancePowerUsageL2']),
        'performance_power_usage_l3': HistoryDataPointItemToJSON(value['performancePowerUsageL3']),
        'pure_air_air_in_temperature': HistoryDataPointItemToJSON(value['pureAirAirInTemperature']),
        'pure_air_air_out_temperature': HistoryDataPointItemToJSON(value['pureAirAirOutTemperature']),
        'pure_air_determined_fan_speed_setpoint': HistoryDataPointItemToJSON(value['pureAirDeterminedFanSpeedSetpoint']),
        'pure_air_estimated_water_valve_position': HistoryDataPointItemToJSON(value['pureAirEstimatedWaterValvePosition']),
        'pure_air_fan_speed': HistoryDataPointItemToJSON(value['pureAirFanSpeed']),
        'requested_heating_temperature': HistoryDataPointItemToJSON(value['requestedHeatingTemperature']),
        'reverse_cycle_position_is_cooling': HistoryDataPointItemToJSON(value['reverseCyclePositionIsCooling']),
        'room_current_uba': HistoryDataPointItemToJSON(value['roomCurrentUba']),
        'supplied_energy_central_heating': HistoryDataPointItemToJSON(value['suppliedEnergyCentralHeating']),
        'supplied_energy_domestic_hot_water': HistoryDataPointItemToJSON(value['suppliedEnergyDomesticHotWater']),
        'supplied_energy_heat_recovery_module': HistoryDataPointItemToJSON(value['suppliedEnergyHeatRecoveryModule']),
        'system_active': HistoryDataPointItemToJSON(value['systemActive']),
        'thermostat_hybrid_ch_enable': HistoryDataPointItemToJSON(value['thermostatHybridChEnable']),
        'ventilation_requested_auto_demand': HistoryDataPointItemToJSON(value['ventilationRequestedAutoDemand']),
        'ventilation_total_energy_consumed': HistoryDataPointItemToJSON(value['ventilationTotalEnergyConsumed']),
        'ventilator_operation_hours': HistoryDataPointItemToJSON(value['ventilatorOperationHours']),
        'ventilator_pwm': HistoryDataPointItemToJSON(value['ventilatorPwm']),
        'water_condenser_water_out_temperature': HistoryDataPointItemToJSON(value['waterCondenserWaterOutTemperature']),
        'water_flow': HistoryDataPointItemToJSON(value['waterFlow']),
        'water_pump_flow': HistoryDataPointItemToJSON(value['waterPumpFlow']),
        'water_pump_status': HistoryDataPointItemToJSON(value['waterPumpStatus']),
        'water_return_temperature': HistoryDataPointItemToJSON(value['waterReturnTemperature']),
        'water_supply_temperature': HistoryDataPointItemToJSON(value['waterSupplyTemperature']),
        'diagnostics': DiagnosticsEmbedToJSON(value['diagnostics']),
        'ambient_offset': HistoryDataPointItemToJSON(value['ambientOffset']),
        'boiler_control_mode': HistoryDataPointItemToJSON(value['boilerControlMode']),
        'calculated_aux_heat_energy': HistoryDataPointItemToJSON(value['calculatedAuxHeatEnergy']),
        'calculated_central_heating_aux_energy_calculated': HistoryDataPointItemToJSON(value['calculatedCentralHeatingAuxEnergyCalculated']),
        'calculated_central_heating_aux_power': HistoryDataPointItemToJSON(value['calculatedCentralHeatingAuxPower']),
        'calculated_central_heating_aux_power_calculated': HistoryDataPointItemToJSON(value['calculatedCentralHeatingAuxPowerCalculated']),
        'calculated_central_heating_heat_pump_energy': HistoryDataPointItemToJSON(value['calculatedCentralHeatingHeatPumpEnergy']),
        'calculated_central_heating_heat_pump_power': HistoryDataPointItemToJSON(value['calculatedCentralHeatingHeatPumpPower']),
        'calculated_cop_heat_pump': HistoryDataPointItemToJSON(value['calculatedCopHeatPump']),
        'calculated_cop_total': HistoryDataPointItemToJSON(value['calculatedCopTotal']),
        'calculated_domestic_hot_water_aux_energy': HistoryDataPointItemToJSON(value['calculatedDomesticHotWaterAuxEnergy']),
        'calculated_domestic_hot_water_aux_energy_calculated': HistoryDataPointItemToJSON(value['calculatedDomesticHotWaterAuxEnergyCalculated']),
        'calculated_domestic_hot_water_aux_power': HistoryDataPointItemToJSON(value['calculatedDomesticHotWaterAuxPower']),
        'calculated_domestic_hot_water_heat_pump_energy': HistoryDataPointItemToJSON(value['calculatedDomesticHotWaterHeatPumpEnergy']),
        'calculated_domestic_hot_water_heat_pump_power': HistoryDataPointItemToJSON(value['calculatedDomesticHotWaterHeatPumpPower']),
        'calculated_electric_energy_l1': HistoryDataPointItemToJSON(value['calculatedElectricEnergyL1']),
        'calculated_electric_energy_l2': HistoryDataPointItemToJSON(value['calculatedElectricEnergyL2']),
        'calculated_electric_energy_l3': HistoryDataPointItemToJSON(value['calculatedElectricEnergyL3']),
        'calculated_electric_energy_total': HistoryDataPointItemToJSON(value['calculatedElectricEnergyTotal']),
        'calculated_heat_pump_heat_energy': HistoryDataPointItemToJSON(value['calculatedHeatPumpHeatEnergy']),
        'calculated_total_energy_calculated': HistoryDataPointItemToJSON(value['calculatedTotalEnergyCalculated']),
        'calculated_total_heat_energy': HistoryDataPointItemToJSON(value['calculatedTotalHeatEnergy']),
        'calculated_total_power_calculated': HistoryDataPointItemToJSON(value['calculatedTotalPowerCalculated']),
        'climate_mode': HistoryDataPointItemToJSON(value['climateMode']),
        'display_brightness': HistoryDataPointItemToJSON(value['displayBrightness']),
        'external_aux_energy': HistoryDataPointItemToJSON(value['externalAuxEnergy']),
        'external_aux_flow': HistoryDataPointItemToJSON(value['externalAuxFlow']),
        'external_aux_power': HistoryDataPointItemToJSON(value['externalAuxPower']),
        'external_aux_return_temperature': HistoryDataPointItemToJSON(value['externalAuxReturnTemperature']),
        'external_aux_supply_temperature': HistoryDataPointItemToJSON(value['externalAuxSupplyTemperature']),
        'external_central_heating_aux_energy_delta': HistoryDataPointItemToJSON(value['externalCentralHeatingAuxEnergyDelta']),
        'external_central_heating_heat_pump_energy_delta': HistoryDataPointItemToJSON(value['externalCentralHeatingHeatPumpEnergyDelta']),
        'external_current_l1': HistoryDataPointItemToJSON(value['externalCurrentL1']),
        'external_current_l2': HistoryDataPointItemToJSON(value['externalCurrentL2']),
        'external_current_l3': HistoryDataPointItemToJSON(value['externalCurrentL3']),
        'external_current_n': HistoryDataPointItemToJSON(value['externalCurrentN']),
        'external_defrost_threshold': HistoryDataPointItemToJSON(value['externalDefrostThreshold']),
        'external_defrost_value': HistoryDataPointItemToJSON(value['externalDefrostValue']),
        'external_degree_minutes': HistoryDataPointItemToJSON(value['externalDegreeMinutes']),
        'external_differential_pressure': HistoryDataPointItemToJSON(value['externalDifferentialPressure']),
        'external_domestic_hot_water_aux_energy_delta': HistoryDataPointItemToJSON(value['externalDomesticHotWaterAuxEnergyDelta']),
        'external_domestic_hot_water_heat_pump_energy_delta': HistoryDataPointItemToJSON(value['externalDomesticHotWaterHeatPumpEnergyDelta']),
        'external_electric_energy_l1': HistoryDataPointItemToJSON(value['externalElectricEnergyL1']),
        'external_electric_energy_l2': HistoryDataPointItemToJSON(value['externalElectricEnergyL2']),
        'external_electric_energy_l3': HistoryDataPointItemToJSON(value['externalElectricEnergyL3']),
        'external_electric_energy_total': HistoryDataPointItemToJSON(value['externalElectricEnergyTotal']),
        'external_electric_power_l1': HistoryDataPointItemToJSON(value['externalElectricPowerL1']),
        'external_electric_power_l2': HistoryDataPointItemToJSON(value['externalElectricPowerL2']),
        'external_electric_power_l3': HistoryDataPointItemToJSON(value['externalElectricPowerL3']),
        'external_electric_power_total': HistoryDataPointItemToJSON(value['externalElectricPowerTotal']),
        'external_energy_delta_total': HistoryDataPointItemToJSON(value['externalEnergyDeltaTotal']),
        'external_total_flow': HistoryDataPointItemToJSON(value['externalTotalFlow']),
        'external_total_heat_energy': HistoryDataPointItemToJSON(value['externalTotalHeatEnergy']),
        'external_total_power': HistoryDataPointItemToJSON(value['externalTotalPower']),
        'external_total_return_temperature': HistoryDataPointItemToJSON(value['externalTotalReturnTemperature']),
        'external_total_supply_temperature': HistoryDataPointItemToJSON(value['externalTotalSupplyTemperature']),
        'external_voltage_l1': HistoryDataPointItemToJSON(value['externalVoltageL1']),
        'external_voltage_l2': HistoryDataPointItemToJSON(value['externalVoltageL2']),
        'external_voltage_l3': HistoryDataPointItemToJSON(value['externalVoltageL3']),
        'external_water_target_temperature': HistoryDataPointItemToJSON(value['externalWaterTargetTemperature']),
        'flame_state': HistoryDataPointItemToJSON(value['flameState']),
        'preheat_setpoint': HistoryDataPointItemToJSON(value['preheatSetpoint']),
        'remote_logging_enabled': HistoryDataPointItemToJSON(value['remoteLoggingEnabled']),
        'room_setpoint': HistoryDataPointItemToJSON(value['roomSetpoint']),
        'ventilation_level': HistoryDataPointItemToJSON(value['ventilationLevel']),
        'weekschedule_state': HistoryDataPointItemToJSON(value['weekscheduleState']),
    };
}

